const ClaimRoute = {
  path: '/claim/:id?',
  load: () => import('./Claim'),
  protected: true,
};

export { ClaimRoute };
